// import { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Mail, Lock, Eye, EyeOff, UserPlus, CheckCircle, XCircle, Globe, User, IdCard } from 'lucide-react';
// import { motion, AnimatePresence } from 'framer-motion';
// import '../styles/login.css';

// import languageLogo from '../assets/Icons/language-icon-matrimony.png';
// import image1 from '../assets/img1.jpg';
// import image2 from '../assets/img2.jpg';
// import image3 from '../assets/img3.jpg';
// import image4 from '../assets/img4.jpg';

// const LoginForm = () => {
//   const [errors, setErrors] = useState({});
//   const [matrimonyId, setMatrimonyId] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState('');
//   const [language, setLanguage] = useState('english');
//   const [showSuccessTick, setShowSuccessTick] = useState(false);
//   const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
//   const navigate = useNavigate();

//   const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
//   const matrimonyIdPattern = /^[A-Za-z0-9]{6,}$/;

//   const translations = {
//     tamil: {
//       welcome: 'வரவேற்பு',
//       loginMessage: 'உங்கள் சரியான வரன்களை கண்டறிய உள்நுழைக',
//       matrimonyId: 'மேட்ரிமோனி ஐடி',
//       matrimonyIdPlaceholder: 'உங்கள் மேட்ரிமோனி ஐடியை உள்ளிடவும்',
//       password: 'கடவுச்சொல்',
//       passwordPlaceholder: 'உங்கள் கடவுச்சொல்லை உள்ளிடவும்',
//       loginButton: 'உள்நுழைக',
//       noAccount: 'கணக்கு இல்லையா?',
//       register: 'பதிவு செய்யவும்',
//       successMessage: 'உள்நுழைவு வெற்றிகரமாக உள்ளது! திருப்பி வழிநடத்தப்படுகிறது...',
//       errorMessage: 'மேட்ரிமோனி ஐடி அல்லது கடவுச்சொல்லை சரிபார்க்கவும் மீண்டும் முயற்சிக்கவும்.',
//       formError: 'படிவத்தில் உள்ள பிழைகளை சரிசெய்யவும்.',
//       close: 'மூடு',
//       switchLanguage: 'மொழி மாற்று',
//       mobileLogin: 'மொபைல் எண் மூலம் உள்நுழையவும்',
//       matrimonyIdRequired: 'மேட்ரிமோனி ஐடி தேவை',
//       invalidMatrimonyId: 'தவறான மேட்ரிமோனி ஐடி',
//       passwordRequired: 'கடவுச்சொல் தேவை',
//       invalidPassword: 'கடவுச்சொல் குறைந்தது 8 எழுத்துகள் மற்றும் எண்கள் இருக்க வேண்டும்',
//     },
//     english: {
//       welcome: 'WELCOME',
//       loginMessage: 'Log in to find your perfect match',
//       matrimonyId: 'Matrimony ID',
//       matrimonyIdPlaceholder: 'Enter your Matrimony ID',
//       password: 'Password',
//       passwordPlaceholder: 'Enter your password',
//       loginButton: 'Login',
//       noAccount: "Don't have an account?",
//       register: 'Register',
//       successMessage: 'Login successful! Redirecting...',
//       errorMessage: 'Please check the Matrimony ID or password and try again.',
//       formError: 'Please fix the errors in the form.',
//       close: 'Close',
//       switchLanguage: 'Switch Language',
//       mobileLogin: 'Login Via Mobile Number',
//       passwordRequired: 'Password is required',
//       invalidPassword: 'Password must be at least 8 characters with letters and numbers',
//       matrimonyIdRequired: 'Matrimony ID is required',
//       invalidMatrimonyId: 'Invalid Matrimony ID',
//     },
//   };

//   const [languageData, setLanguageData] = useState(translations[language]);

//   useEffect(() => {
//     const storedLanguage = localStorage.getItem('selectedLanguage');
//     if (storedLanguage) {
//       setLanguage(storedLanguage);
//     } else {
//       navigate('/');
//     }
//   }, [navigate]);

//   useEffect(() => {
//     setLanguageData(translations[language]);
//   }, [language]);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!matrimonyId) newErrors.matrimonyId = translations[language].matrimonyIdRequired;
//     else if (!matrimonyIdPattern.test(matrimonyId)) newErrors.matrimonyId = translations[language].invalidMatrimonyId;
//     if (!password) newErrors.password = translations[language].passwordRequired;
//     else if (!passwordPattern.test(password)) newErrors.password = translations[language].invalidPassword;
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return setSubmitStatus('error');

//     try {
//       const response = await fetch('https://backend.newbrindha.com/matrimony/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           matrimony_id: matrimonyId,
//           password: password,
//         }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         if (data.access_token) localStorage.setItem('authToken', data.access_token);
//         setSubmitStatus('success');
//         setShowSuccessTick(true);
//         setTimeout(() => navigate('/dashboard'), 1000);
//       } else {
//         setSubmitStatus('error');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       setSubmitStatus('error');
//     }
//   };

//   const toggleLanguageDropdown = () => {
//     setShowLanguageDropdown((prev) => !prev);
//   };

//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     setShowLanguageDropdown(false);
//   };

// const dropdownRef = useRef(null);

// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setShowLanguageDropdown(false);
//     }
//   };
//   document.addEventListener('mousedown', handleClickOutside);
//   return () => {
//     document.removeEventListener('mousedown', handleClickOutside);
//   };
// }, []);

//   return (
//     <div className="min-h-screen flex items-center justify-center p-4 overflow-hidden relative bg-gray-100">
//       {/* Background Images */}
//       <div className="absolute inset-0 grid grid-cols-1 sm:grid-cols-4 gap-0 z-0">
//         {[
//           image1,image2,image3,image4,

//         ].map((img, i) => (
//           <div key={i} className="h-full w-full bg-cover bg-center transform transition-transform duration-500 hover:scale-110" style={{ backgroundImage: `url(${img})` }} />
//         ))}
//       </div>
//       {/* <div className='absolute inset-0 w-full h-screen bg-black opacity-30 overflow-y-hidden overflow-x-hidden'></div> */}

//       {/* Globe Icon for Language Toggle */}
//       <div ref={dropdownRef} className="absolute top-4 right-4 z-20">
//         <button
//           onClick={toggleLanguageDropdown}
//           className="bg-white text-[#d35400] p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
//         >
//           <img src={languageLogo} alt="language-logo" className="h-8 w-8" />
//         </button>

//         {showLanguageDropdown && (
//           <motion.div
//             initial={{ opacity: 0, y: -10 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -10 }}
//             transition={{ duration: 0.2 }}
//             className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20"
//           >
//             <button
//               onClick={() => handleLanguageChange('english')}
//               className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-t-lg"
//             >
//               English
//             </button>
//             <button
//               onClick={() => handleLanguageChange('tamil')}
//               className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-b-lg"
//             >
//               தமிழ்
//             </button>
//           </motion.div>
//         )}
//       </div>

//       {/* Login Form */}
//       <motion.div
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className="bg-white/60 backdrop-blur-sm rounded-2xl shadow-lg p-6 w-full max-w-sm border border-[#f39c12]/20 relative z-10 mx-4"
//       >
//         <div className="flex justify-center mb-6">
//           <motion.div
//             whileHover={{ scale: 1.1 }}
//             className="w-16 h-16 bg-gradient-to-r from-[#f39c12] to-[#d35400] rounded-2xl flex items-center justify-center transform rotate-12 hover:rotate-0 transition-transform duration-300"
//           >
//             <User className="h-8 w-8 text-white transform -rotate-12" />
//           </motion.div>
//         </div>

//         <div className="text-center mb-6">
//           <h2 className="text-3xl font-bold text-[#d35400] mb-2 tracking-tight">{languageData.welcome}</h2>
//           <p className="text-[#e67e22] text-sm">{languageData.loginMessage}</p>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <InputField
//             type="text"
//             name="matrimonyId"
//             value={matrimonyId}
//             onChange={(e) => setMatrimonyId(e.target.value)}
//             placeholder={languageData.matrimonyIdPlaceholder}
//             error={errors.matrimonyId}
//             icon={<User className="h-5 w-5 text-[#e67e22]" />}
//             label={languageData.matrimonyId}
//           />

//           <InputField
//             type={showPassword ? 'text' : 'password'}
//             name="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             placeholder={languageData.passwordPlaceholder}
//             error={errors.password}
//             icon={<Lock className="h-5 w-5 text-[#e67e22]" />}
//             togglePassword={() => setShowPassword(!showPassword)}
//             showPassword={showPassword}
//             label={languageData.password}
//           />

//           {submitStatus === 'error' && <ErrorMessage message={languageData.errorMessage} />}

//           <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.4 }} className="pt-2">
//             <button type="submit" className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white py-2 px-4 rounded-lg font-medium hover:from-[#f39c12]/90 hover:to-[#d35400]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30">
//               {languageData.loginButton}
//             </button>
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.4 }}
//             className="pt-2"
//           >
//             <a
//               href="/another"  // Replace this with the actual link for mobile login
//               className="w-full text-center block bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white py-2 px-4 rounded-lg font-medium hover:from-[#f39c12]/90 hover:to-[#d35400]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30 no-underline"
//             >
//               {languageData.mobileLogin}
//             </a>
//           </motion.div>

//           <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.6 }} className="mt-4 text-center">
//             <div className="relative flex justify-center text-sm">
//               <span className="px-2 bg-transparent text-[#e67e22]">{languageData.noAccount}</span>
//             </div>
//             <a href="/mobile" className="inline-flex items-center justify-center gap-2 mt-2 text-[#e67e22] hover:text-[#f39c12] transition-colors duration-200">
//               <UserPlus className="h-4 w-4" />
//               <span className="font-medium text-sm">{languageData.register}</span>
//             </a>
//           </motion.div>
//         </form>

//         <AnimatePresence>
//           {showSuccessTick && (
//             <motion.div initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0 }} transition={{ duration: 0.5 }} className="fixed inset-0 flex items-center justify-center bg-transparent backdrop-blur-sm z-50">
//               <CheckCircle className="h-16 w-16 text-green-500" />
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </motion.div>
//     </div>
//   );
// };

// const InputField = ({
//   type,
//   name,
//   value,
//   onChange,
//   placeholder,
//   error,
//   icon,
//   togglePassword,
//   showPassword,
//   label,
// }) => {
//   const inputType = name === 'password' && showPassword ? 'text' : type;

//   return (
//     <motion.div
//       initial={{ opacity: 0, x: type === 'email' ? -20 : 20 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.5, delay: type === 'email' ? 0.2 : 0.4 }}
//     >
//       <label htmlFor={name} className="block text-sm font-medium text-[#d35400] mb-1">
//         {label}
//       </label>
//       <div className="relative">
//         <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
//           {icon}
//         </div>
//         <input
//           id={name}
//           name={name}
//           type={inputType}
//           value={value}
//           onChange={onChange}
//           className={`block w-full pl-10 pr-10 py-2 bg-transparent border ${
//             error ? 'border-red-500' : 'border-[#e67e22]/30'
//           } text-[#d35400] rounded-lg focus:ring-2 focus:ring-[#f39c12] focus:border-[#f39c12] transition-all duration-200 ease-in-out focus:shadow-md focus:shadow-[#f39c12]/20`}
//           placeholder={placeholder}
//         />
//         {name === 'password' && (
//           <button
//             type="button"
//             className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#e67e22] hover:text-[#f39c12] transition-colors duration-200 z-10"
//             onClick={togglePassword}
//           >
//             {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
//           </button>
//         )}
//       </div>
//       {error && (
//         <motion.div
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.2 }}
//           className="mt-1 text-sm text-red-500 flex items-center gap-1"
//         >
//           <XCircle className="h-4 w-4" />
//           <span>{error}</span>
//         </motion.div>
//       )}
//     </motion.div>
//   );
// };

// const ErrorMessage = ({ message }) => (
//   <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.2 }} className="text-sm text-red-500 flex items-center gap-1 justify-center">
//     <XCircle className="h-4 w-4" />
//     <span>{message}</span>
//   </motion.div>
// );

// export default LoginForm;

import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  UserPlus,
  CheckCircle,
  XCircle,
  User,
  ArrowLeft,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import "../styles/login.css";

import languageLogo from "../assets/Icons/language-icon-matrimony.png";
import image1 from "../assets/img1.jpg";
import image2 from "../assets/img2.jpg";
import image3 from "../assets/img3.jpg";
import image4 from "../assets/img4.jpg";
import logoes from "../assets/Logo3.png";

const LoginForm = () => {
  const { t, i18n } = useTranslation();
  const [errors, setErrors] = useState({});
  const [matrimonyId, setMatrimonyId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");
  const [language, setLanguage] = useState("english");
  const [showSuccessTick, setShowSuccessTick] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [matrimonyIdFromEmail, setMatrimonyIdFromEmail] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [emailVerificationStatus, setEmailVerificationStatus] = useState(null);
  const navigate = useNavigate();

  const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
  const matrimonyIdPattern = /^[A-Za-z0-9]{6,}$/;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const translations = {
    tamil: {
      welcome: "வரவேற்பு",
      loginMessage: "உங்கள் சரியான வரன்களை கண்டறிய உள்நுழைக",
      matrimonyId: "மேட்ரிமோனி ஐடி",
      matrimonyIdPlaceholder: "உங்கள் மேட்ரிமோனி ஐடியை உள்ளிடவும்",
      password: "கடவுச்சொல்",
      passwordPlaceholder: "உங்கள் கடவுச்சொல்லை உள்ளிடவும்",
      loginButton: "உள்நுழைக",
      noAccount: "கணக்கு இல்லையா?",
      register: "பதிவு செய்யவும்",
      successMessage:
        "உள்நுழைவு வெற்றிகரமாக உள்ளது! திருப்பி வழிநடத்தப்படுகிறது...",
      errorMessage:
        "மேட்ரிமோனி ஐடி அல்லது கடவுச்சொல்லை சரிபார்க்கவும் மீண்டும் முயற்சிக்கவும்.",
      formError: "படிவத்தில் உள்ள பிழைகளை சரிசெய்யவும்.",
      close: "மூடு",
      switchLanguage: "மொழி மாற்று",
      mobileLogin: "மொபைல் எண் மூலம் உள்நுழையவும்",
      matrimonyIdRequired: "மேட்ரிமோனி ஐடி தேவை",
      invalidMatrimonyId: "தவறான மேட்ரிமோனி ஐடி",
      passwordRequired: "கடவுச்சொல் தேவை",
      invalidPassword:
        "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் மற்றும் எண்கள் இருக்க வேண்டும்",
      forgotPassword: "கடவுச்சொல் மறந்துவிட்டீர்களா?",
      resetPassword: "கடவுச்சொல்லை மீட்டமைக்க",
      backToLogin: "உள்நுழைய மீண்டும் செல்லவும்",
      email: "மின்னஞ்சல்",
      emailPlaceholder: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
      emailRequired: "மின்னஞ்சல் தேவை",
      invalidEmail: "தவறான மின்னஞ்சல் முகவரி",
      newPassword: "புதிய கடவுச்சொல்",
      newPasswordPlaceholder: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
      confirmPassword: "கடவுச்சொலை உறுதிப்படுத்தவும்",
      confirmPasswordPlaceholder: "கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
      passwordsNotMatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
      verifyEmail: "மின்னஞ்சலை சரிபார்க்கவும்",
      emailVerifiedMessage:
        "மின்னஞ்சல் சரிபார்க்கப்பட்டது! தயவுசெய்து உங்கள் புதிய கடவுச்சொல்லை உள்ளிடவும்.",
      emailNotRegistered: "இந்த மின்னஞ்சல் பதிவு செய்யப்படவில்லை",
      passwordResetSuccess: "கடவுச்சொல் வெற்றிகரமாக மீட்டமைக்கப்பட்டது!",
      passwordMismatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
      passwordResetError: "கடவுச்சொல்லை மீட்டமைக்கும் போது பிழை ஏற்பட்டது",
      emailVerifySuccess: "மின்னஞ்சல் சரிபார்க்கப்பட்டது!",
    },
    english: {
      welcome: "WELCOME",
      loginMessage: "Log in to find your perfect match",
      matrimonyId: "Matrimony ID",
      matrimonyIdPlaceholder: "Enter your Matrimony ID",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      loginButton: "Login",
      noAccount: "Don't have an account?",
      register: "Register",
      successMessage: "Login successful! Redirecting...",
      errorMessage: "Please check the Matrimony ID or password and try again.",
      formError: "Please fix the errors in the form.",
      close: "Close",
      switchLanguage: "Switch Language",
      mobileLogin: "Login Via Mobile Number",
      passwordRequired: "Password is required",
      invalidPassword:
        "Password must be at least 8 characters with letters and numbers",
      matrimonyIdRequired: "Matrimony ID is required",
      invalidMatrimonyId: "Invalid Matrimony ID",
      forgotPassword: "Forgot Password?",
      resetPassword: "Reset Password",
      backToLogin: "Back to Login",
      email: "Email",
      emailPlaceholder: "Enter your email",
      emailRequired: "Email is required",
      invalidEmail: "Invalid email address",
      newPassword: "New Password",
      newPasswordPlaceholder: "Enter new password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Re-enter your password",
      passwordsNotMatch: "Passwords do not match",
      verifyEmail: "Verify Email",
      emailVerifiedMessage: "Email verified! Please enter your new password.",
      emailNotRegistered: "This email is not registered",
      passwordResetSuccess: "Password reset successfully!",
      passwordMismatch: "Passwords do not match",
      passwordResetError: "Error resetting password",
      emailVerifySuccess: "Email verified successfully!",
    },
  };

  const [languageData, setLanguageData] = useState(translations[language]);

  // Initialize language from localStorage and sync with i18n on component mount
  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    let languageToUse = "english";
    let i18nLanguage = "en";

    if (storedLanguage) {
      if (storedLanguage === "ta") {
        languageToUse = "tamil";
        i18nLanguage = "ta";
      } else if (storedLanguage === "en") {
        languageToUse = "english";
        i18nLanguage = "en";
      } else if (storedLanguage === "tamil") {
        languageToUse = "tamil";
        i18nLanguage = "ta";
      } else if (storedLanguage === "english") {
        languageToUse = "english";
        i18nLanguage = "en";
      }
    }

    setLanguage(languageToUse);
    setLanguageData(translations[languageToUse]);

    // Sync with i18n
    if (i18n.language !== i18nLanguage) {
      i18n.changeLanguage(i18nLanguage);
    }
  }, [i18n]);

  // Listen for languageChanged event to sync language changes across components
  useEffect(() => {
    const handleLanguageChangeEvent = (event) => {
      const newI18nLang = event.detail.language;
      const newLang = newI18nLang === "ta" ? "tamil" : "english";

      setLanguage(newLang);
      setLanguageData(translations[newLang]);

      // Sync with i18n
      if (i18n.language !== newI18nLang) {
        i18n.changeLanguage(newI18nLang);
      }
    };

    window.addEventListener("languageChanged", handleLanguageChangeEvent);
    return () => {
      window.removeEventListener("languageChanged", handleLanguageChangeEvent);
    };
  }, [i18n]);

  const validateForm = () => {
    const newErrors = {};
    if (!matrimonyId)
      newErrors.matrimonyId = translations[language].matrimonyIdRequired;
    else if (!matrimonyIdPattern.test(matrimonyId))
      newErrors.matrimonyId = translations[language].invalidMatrimonyId;
    if (!password) newErrors.password = translations[language].passwordRequired;
    else if (!passwordPattern.test(password))
      newErrors.password = translations[language].invalidPassword;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEmail = () => {
    const newErrors = {};
    if (!email) newErrors.email = translations[language].emailRequired;
    else if (!emailPattern.test(email))
      newErrors.email = translations[language].invalidEmail;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePasswordReset = () => {
    const newErrors = {};
    if (!newPassword) {
      newErrors.newPassword = translations[language].passwordRequired;
    } else if (!passwordPattern.test(newPassword)) {
      newErrors.newPassword = translations[language].invalidPassword;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = translations[language].passwordRequired;
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = translations[language].passwordMismatch;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return setSubmitStatus("error");

    try {
      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            matrimony_id: matrimonyId,
            password: password,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.access_token)
          localStorage.setItem("authToken", data.access_token);
        if (data.matrimony_id)
          localStorage.setItem("MatrimonyId", data.matrimony_id);

        // Ensure language persists after login
        const currentI18nLang = language === "tamil" ? "ta" : "en";
        localStorage.setItem("language", currentI18nLang);

        // Dispatch language change event to ensure all components sync
        window.dispatchEvent(
          new CustomEvent("languageChanged", {
            detail: { language: currentI18nLang },
          })
        );

        setSubmitStatus("success");
        setShowSuccessTick(true);
        setTimeout(() => navigate("/dashboard"), 1000);
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus("error");
    }
  };

  const handleForgotPassword = () => {
    setForgotPasswordMode(true);
    setEmailVerified(false);
    setResetSuccess(false);
    setEmail("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    setSubmitStatus("");
    setEmailVerificationStatus(null);
  };

  const handleBackToLogin = () => {
    setForgotPasswordMode(false);
    setEmailVerified(false);
    setResetSuccess(false);
    setEmail("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    setSubmitStatus("");
    setEmailVerificationStatus(null);
  };

  const handleVerifyEmail = async (e) => {
    e.preventDefault();
    if (!validateEmail()) return setSubmitStatus("error");

    try {
      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/verify-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setMatrimonyIdFromEmail(data.matrimony_id);
        setEmailVerified(true);
        setErrors({});
        setEmailVerificationStatus("success");
      } else if (response.status === 404) {
        setErrors({ email: translations[language].emailNotRegistered });
        setEmailVerificationStatus("error");
      } else {
        setErrors({ email: translations[language].emailNotRegistered });
        setEmailVerificationStatus("error");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrors({ email: translations[language].emailNotRegistered });
      setEmailVerificationStatus("error");
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!validatePasswordReset()) return;

    try {
      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/forgot-password",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            new_password: newPassword,
            confirm_password: confirmPassword,
          }),
        }
      );

      if (response.ok) {
        setResetSuccess(true);
        setShowSuccessTick(true);
        setTimeout(() => {
          setForgotPasswordMode(false);
          setEmailVerified(false);
          setResetSuccess(false);
          setShowSuccessTick(false);
          setEmail("");
          setNewPassword("");
          setConfirmPassword("");
        }, 2000);
      } else {
        setErrors({
          confirmPassword: translations[language].passwordResetError,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setErrors({ confirmPassword: translations[language].passwordResetError });
    }
  };

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setLanguageData(translations[lang]);
    setShowLanguageDropdown(false);

    // Convert to i18n format and store
    const i18nLang = lang === "english" ? "en" : "ta";
    localStorage.setItem("language", i18nLang);

    // Sync with i18n immediately
    i18n.changeLanguage(i18nLang);

    // Dispatch custom event to notify other components
    window.dispatchEvent(
      new CustomEvent("languageChanged", {
        detail: { language: i18nLang },
      })
    );

    // Force a broader update to ensure all components receive the change
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("forceLanguageSync", {
          detail: { language: i18nLang },
        })
      );
    }, 100);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLanguageDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 overflow-hidden relative bg-gray-100">
      {/* Back Arrow Button */}
      <button
        onClick={() => navigate("/howitswork")}
        className="absolute top-4 left-4 z-20 bg-white/60 text-[#d35400] p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30 sm:top-3 sm:left-3 md:top-4 md:left-4 lg:top-5 lg:left-5 xl:top-6 xl:left-6"
      >
        <ArrowLeft className="h-5 w-5 sm:h-4 sm:w-4 md:h-5 md:w-5 lg:h-6 lg:w-6 xl:h-6 xl:w-6" />
      </button>
      {/* Background Images */}
      <div className="absolute inset-0 grid grid-cols-1 sm:grid-cols-4 gap-0 z-0">
        {[image1, image2, image3, image4].map((img, i) => (
          <div
            key={i}
            className="h-full w-full bg-cover bg-center transform transition-transform duration-500 hover:scale-110"
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>

      {/* Globe Icon for Language Toggle */}
      <div ref={dropdownRef} className="absolute top-4 right-4 z-20">
        <button
          onClick={toggleLanguageDropdown}
          className="bg-white text-[#d35400] p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
        >
          <img src={languageLogo} alt="language-logo" className="h-8 w-8" />
        </button>

        {showLanguageDropdown && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20"
          >
            <button
              onClick={() => handleLanguageChange("english")}
              className={`w-full text-left px-4 py-2 hover:bg-[#f39c12] hover:text-white rounded-t-lg transition-colors ${
                language === "english"
                  ? "bg-[#f39c12] text-white"
                  : "text-[#d35400]"
              }`}
            >
              English
            </button>
            <button
              onClick={() => handleLanguageChange("tamil")}
              className={`w-full text-left px-4 py-2 hover:bg-[#f39c12] hover:text-white rounded-b-lg transition-colors ${
                language === "tamil"
                  ? "bg-[#f39c12] text-white"
                  : "text-[#d35400]"
              }`}
            >
              தமிழ்
            </button>
          </motion.div>
        )}
      </div>

      {/* Login Form */}
      <motion.div
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white/60 backdrop-blur-sm rounded-2xl shadow-lg p-6 w-full max-w-sm border border-[#f39c12]/20 relative z-10 mx-4 sm:mx-auto"
      >
        <div className="flex justify-center mb-6">
          <img
            src={logoes}
            alt="User"
            className="h-24 w-24 object-contain" 
          />
        </div>


        {!forgotPasswordMode ? (
          <>
            <div className="text-center mb-6">
              <h2 className="text-3xl font-bold text-[#d35400] mb-2 tracking-tight">
                {languageData.welcome}
              </h2>
              <p className="text-[#e67e22] text-sm">
                {languageData.loginMessage}
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <InputField
                type="text"
                name="matrimonyId"
                value={matrimonyId}
                onChange={(e) => setMatrimonyId(e.target.value)}
                placeholder={languageData.matrimonyIdPlaceholder}
                error={errors.matrimonyId}
                icon={<User className="h-5 w-5 text-[#e67e22]" />}
                label={languageData.matrimonyId}
              />

              <InputField
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={languageData.passwordPlaceholder}
                error={errors.password}
                icon={<Lock className="h-5 w-5 text-[#e67e22]" />}
                togglePassword={() => setShowPassword(!showPassword)}
                showPassword={showPassword}
                label={languageData.password}
              />

              <div className="text-right">
                <button
                  type="button"
                  onClick={handleForgotPassword}
                  className="text-sm text-[#e67e22] hover:text-[#d35400] font-medium"
                >
                  {languageData.forgotPassword}
                </button>
              </div>

              {submitStatus === "error" && (
                <ErrorMessage message={languageData.errorMessage} />
              )}

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="pt-2"
              >
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white py-2 px-4 rounded-lg font-medium hover:from-[#f39c12]/90 hover:to-[#d35400]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
                >
                  {languageData.loginButton}
                </button>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="pt-2"
              >
                <a
                  href="/another"
                  className="w-full text-center block bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white py-2 px-4 rounded-lg font-medium hover:from-[#f39c12]/90 hover:to-[#d35400]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30 no-underline"
                >
                  {languageData.mobileLogin}
                </a>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                className="mt-4 text-center"
              >
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-transparent text-[#e67e22]">
                    {languageData.noAccount}
                  </span>
                </div>
                <a
                  href="/mobile"
                  className="inline-flex items-center justify-center gap-2 mt-2 text-[#e67e22] hover:text-[#f39c12] transition-colors duration-200"
                >
                  <UserPlus className="h-4 w-4" />
                  <span className="font-medium text-sm">
                    {languageData.register}
                  </span>
                </a>
              </motion.div>
            </form>
          </>
        ) : (
          <>
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-[#d35400] mb-2 tracking-tight">
                {languageData.resetPassword}
              </h2>
              <p className="text-[#e67e22] text-sm">
                {emailVerified
                  ? languageData.emailVerifiedMessage
                  : languageData.loginMessage}
              </p>
            </div>

            {emailVerificationStatus === "success" && (
              <SuccessMessage message={languageData.emailVerifySuccess} />
            )}

            <button
              onClick={handleBackToLogin}
              className="flex items-center text-[#e67e22] hover:text-[#d35400] mb-4"
            >
              <ArrowLeft className="h-4 w-4 mr-1" />
              <span className="text-sm font-medium">
                {languageData.backToLogin}
              </span>
            </button>

            {!emailVerified ? (
              <form onSubmit={handleVerifyEmail} className="space-y-4">
                <InputField
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={languageData.emailPlaceholder}
                  error={errors.email}
                  icon={<Mail className="h-5 w-5 text-[#e67e22]" />}
                  label={languageData.email}
                />

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="pt-2"
                >
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white py-2 px-4 rounded-lg font-medium hover:from-[#f39c12]/90 hover:to-[#d35400]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
                  >
                    {languageData.verifyEmail}
                  </button>
                </motion.div>
              </form>
            ) : (
              <form onSubmit={handlePasswordReset} className="space-y-4">
                <InputField
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder={languageData.newPasswordPlaceholder}
                  error={errors.newPassword}
                  icon={<Lock className="h-5 w-5 text-[#e67e22]" />}
                  togglePassword={() => setShowNewPassword(!showNewPassword)}
                  showPassword={showNewPassword}
                  label={languageData.newPassword}
                />

                <InputField
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder={languageData.confirmPasswordPlaceholder}
                  error={errors.confirmPassword}
                  icon={<Lock className="h-5 w-5 text-[#e67e22]" />}
                  togglePassword={() =>
                    setShowConfirmPassword(!showConfirmPassword)
                  }
                  showPassword={showConfirmPassword}
                  label={languageData.confirmPassword}
                />

                {resetSuccess && (
                  <SuccessMessage message={languageData.passwordResetSuccess} />
                )}

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="pt-2"
                >
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white py-2 px-4 rounded-lg font-medium hover:from-[#f39c12]/90 hover:to-[#d35400]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
                  >
                    {languageData.resetPassword}
                  </button>
                </motion.div>
              </form>
            )}
          </>
        )}

        <AnimatePresence>
          {showSuccessTick && (
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0 }}
              transition={{ duration: 0.5 }}
              className="fixed inset-0 flex items-center justify-center bg-transparent backdrop-blur-sm z-50"
            >
              <CheckCircle className="h-16 w-16 text-green-500" />
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

const InputField = ({
  type,
  name,
  value,
  onChange,
  placeholder,
  error,
  icon,
  togglePassword,
  showPassword,
  label,
}) => {
  const inputType =
    (name === "password" ||
      name === "newPassword" ||
      name === "confirmPassword") &&
    showPassword
      ? "text"
      : type;

  return (
    <motion.div
      initial={{ opacity: 0, x: type === "email" ? -20 : 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: type === "email" ? 0.2 : 0.4 }}
    >
      <label
        htmlFor={name}
        className="block text-sm font-medium text-[#d35400] mb-1"
      >
        {label}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
          {icon}
        </div>
        <input
          id={name}
          name={name}
          type={inputType}
          value={value}
          onChange={onChange}
          className={`block w-full pl-10 pr-10 py-2 bg-transparent border ${
            error ? "border-red-500" : "border-[#e67e22]/30"
          } text-[#d35400] rounded-lg focus:ring-2 focus:ring-[#f39c12] focus:border-[#f39c12] transition-all duration-200 ease-in-out focus:shadow-md focus:shadow-[#f39c12]/20`}
          placeholder={placeholder}
        />
        {(name === "password" ||
          name === "newPassword" ||
          name === "confirmPassword") && (
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#e67e22] hover:text-[#f39c12] transition-colors duration-200 z-10"
            onClick={togglePassword}
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5" />
            ) : (
              <Eye className="h-5 w-5" />
            )}
          </button>
        )}
      </div>
      {error && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="mt-1 text-sm text-red-500 flex items-center gap-1"
        >
          <XCircle className="h-4 w-4" />
          <span>{error}</span>
        </motion.div>
      )}
    </motion.div>
  );
};

const ErrorMessage = ({ message }) => (
  <motion.div
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.2 }}
    className="text-sm text-red-500 flex items-center gap-1 justify-center"
  >
    <XCircle className="h-4 w-4" />
    <span>{message}</span>
  </motion.div>
);

const SuccessMessage = ({ message }) => (
  <motion.div
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.2 }}
    className="text-sm text-green-500 flex items-center gap-1 justify-center mb-4"
  >
    <CheckCircle className="h-4 w-4" />
    <span>{message}</span>
  </motion.div>
);

export default LoginForm;
